export default function HeroBanner() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20lifestyle%20flat%20lay%20with%20designer%20sneakers%20next%20to%20a%20coffee%20cup%20and%20notebook%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20morning%20sunlight%20from%20a%20nearby%20window%20creating%20gentle%20shadows%2C%20editorial%20minimal%20composition%20with%20organic%20textures&width=1600&height=900&seq=hero-bg-acbuy-v3&orientation=landscape"
          alt="AcBuy Spreadsheet curated products collection featuring fashion items and accessories"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/85 via-background-50/40 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-xl pt-24 md:pt-0">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100/80 rounded-full mb-6">
            <div className="w-1.5 h-1.5 rounded-full bg-accent-500"></div>
            <span className="text-xs font-medium text-accent-800 whitespace-nowrap">Updated Daily for 2026</span>
          </div>

          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-tight mb-5">
            AcBuy Spreadsheet:
            <br />
            <span className="text-primary-500">Best Finds</span> &amp; Shopping Guides
          </h2>

          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8 max-w-md">
            Explore curated products, trusted guides, QC resources, shipping tips, and the latest AcBuy Spreadsheet updates — all in one place.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              AcBuy Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-950 hover:bg-foreground-800 text-background-50 font-semibold text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-4 mt-8 pt-8 border-t border-foreground-200/40">
            {[
              { icon: 'ri-refresh-line', label: 'Updated Daily' },
              { icon: 'ri-shield-check-line', label: 'QC Checked' },
              { icon: 'ri-ship-line', label: 'Multi-Shipping' },
            ].map((badge) => (
              <div key={badge.label} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${badge.icon} text-accent-600 text-sm`}></i>
                </div>
                <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}